<div class="buttons-container">
    <ng-container *ngIf="!loading else loader">
        <ng-container *ngIf="!popupOnPermission">
            <ng-container *ngIf="type !== 'link'">
                <button type="button" [ngClass]="[type, iconPosition]"
                [disabled]="disabledBtn" (click)="btnClick($event)">
                <mat-icon [ngClass]="{'notranslate':true, 'material-icons-rounded':outlinedIcon}"
                    *ngIf="!!icon">{{icon}}</mat-icon>
                {{label}}
                </button>
            </ng-container>
            
            <ng-container *ngIf="type === 'link'">
                <a (click)="btnClick($event)">{{label}}</a>
            </ng-container>
        </ng-container>
    
        <ng-container *ngIf="popupOnPermission">
            <ng-container *ngIf="type !== 'link'">
                <button terraCheckPermissions
                [minimumViewAsInvestorPermission]="minimumViewAsInvestorPermission"
                [minimumPermissionLevel]="minimumPermissionLevel"
                [minimumFinancialPermissionLevel]="minimumFinancialPermissionLevel"
                [sectionsAccess]="sectionsAccess"
                [requireContactsVisibility]="requireContactsVisibility"
                [noPermissionAction]="NoPermissionAction.PopupOnClick" type="button" [ngClass]="[type, iconPosition]"
                [disabled]="disabledBtn" (click)="btnClick($event)">
                <mat-icon [ngClass]="{'notranslate':true, 'material-icons-outlined':outlinedIcon}"
                    *ngIf="!!icon">{{icon}}</mat-icon>
                {{label}}
            </button>
            </ng-container>
            
            <ng-container *ngIf="type === 'link'">
                <a (click)="btnClick($event)">{{label}}</a>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-template #loader>
        <terra-loader></terra-loader>
    </ng-template>
</div>